export default __webpack_public_path__ + "static/media/CS-Mani-Mobile.6cc69ebb.webp";